import React, { Component } from 'react';
import Card from '@material-ui/core/Card';

class Faq extends Component {
    render() {
        return <Card style={{padding: '10px'}}>
            <h1>Częste pytania</h1>           
            <p><b>Nie mogę nagrywać ćwiczeń. Pojawia się komunikat o błędzie.</b></p>
            <p>Jest to prawdopodobnie spowodowane faktem, że <b>nie</b> nadałeś aplikacji uprawnienia do korzystania z mikrofonu. Blokowanie mikrofonu jest notyfikowane przez przeglądarkę internetową za pomocą odpowiedniej ikony. Przykładowo w przeglądarce chrome zobaczysz ikonkę <img src="" style="float: left"/> a na przeglądarce firefox <img src="" style="float: left"/>. </p>
        </Card>
    }
}

export default Faq;